import classes from "./transaction-history-container.module.css";

function EmptyState() {
  return (
    <div className={classes.noData}>
      <img
        src="/hire/transaction-history-empty.svg"
        alt="empty-state"
        width={228}
        height={182}
        className={classes.noDataIcon}
      />
      No Transactions at this time
    </div>
  );
}

export default EmptyState;
